var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.wrapp},[_c('span',{class:_vm.$style.code},[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('UiRichText',{class:_vm.$style.content,attrs:{"content":_vm.bodytext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }